import React from 'react'
import Component from 'components/component'

export default class Spoiler extends Component {
  static defaultProps = {
    defaultOpen: false,
    className: 'j-spoiler',
    headClassName: 'j-spoiler-head',
    bodyClassName: 'j-spoiler-body',
  }

  state = {
    open: this.props.defaultOpen,
  }

  toggle = ev => {
    ev.preventDefault()
    this.setState(state => {
      if (typeof this.props.onChange === 'function') {
        this.props.onChange(!state.open)
      }

      return {
        open: !state.open,
      }
    })
  }

  render() {
    const open = this.state.open
    return (
      <div className={this.classList(this.props.className, open && '_opened')}>
        <button
          type="button"
          className={this.classList(
            this.props.headClassName,
            open && '_opened'
          )}
          onClick={this.toggle}
        >
          {this.props.title}
        </button>
        <div
          className={this.classList(
            this.props.bodyClassName,
            open && '_opened'
          )}
        >
          {this.props.children}
        </div>
      </div>
    )
  }
}
